import AuthRedirect from "components/AuthComponents/Landing";
import ConditionalNavWrapper from "components/ConditionalNavWrapper";
import Head from "next/head";
import React from "react";

export default function ProviderAuthLanding() {
  return (
    <ConditionalNavWrapper>
      <Head>
        <title>Service Provider Login</title>
      </Head>
      <AuthRedirect userType="vendor" />
    </ConditionalNavWrapper>
  );
}
